import React from 'react';
import { useSelector } from 'react-redux';
import logoImageLight from '../../assets/images/slimstock-logo-figma.png';
import logoImageDark from '../../assets/images/slimstock-logo-figma-dark.png';
import Menu from './Menu.jsx';
import t from "../../helpers/translator";

const Header = () => {

    const auth = useSelector(state => state.user);

    return (
        auth.user_type === '' || auth.user_type === 'player' ?
            <header className="header">
                <div className="logoWrapper"><img className="logo" src={logoImageLight} alt="logo" /></div>
                <div className="gameName">{t("S&OP Game")}</div>
            </header>
            :
            <header className="header whiteBG borderBottom">
                <div className="logoWrapper dark"><img className="logo" src={logoImageDark} alt="logo" /></div>
                <div className="gameNameDark">{t("S&OP")} <span className="otherBlue">{t("Game")}</span></div>
                <Menu />
            </header>
            
    );
};

export default Header;